<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboards',
            icon: 'ni ni-shop text-primary',
          }"
        >
          <sidebar-item :link="{ name: 'Fleet overview', path: '/overview' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Fleet driving style', path: '/drivingstyle' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
                  name: 'Management',
                  icon: 'ni ni-ungroup text-orange'
                  }">
          <sidebar-item :link="{ name: 'Overview', path: '/management/overview' }"/>
          <sidebar-item :link="{ name: 'Assets', path: '/management/assets' }"/>
          <sidebar-item :link="{ name: 'Devices', path: '/management/devices' }"/>
          <sidebar-item :link="{ name: 'Drivers', path: '/management/drivers' }"/>
          <sidebar-item :link="{ name: 'Groups', path: '/management/groups' }"/>
          <sidebar-item :link="{ name: 'Configuration groups', path: '/management/configurationgroups' }"/>
          <sidebar-item :link="{ name: 'Users', path: '/management/users' }"/>
          <sidebar-item :link="{ name: 'Synchronization', path: '/management/synchronization' }" v-if="$store.state.auth.user.user_role === 'OEM'"/>
          <sidebar-item :link="{ name: 'Organisation settings', path: '/management/organisationsettings' }" v-if="$store.state.auth.user.user_role === 'OEM' || $store.state.auth.user.user_role === 'RESELLER'"/>
        </sidebar-item>
        <sidebar-item v-if="$store.state.auth.user.user_role === 'OEM'" :link="{
                  name: 'OEM',
                  icon: 'ni ni-world-2 text-red'
                  }">
          <sidebar-item :link="{ name: 'Admin', path: '/oem/admin' }" v-if="$store.state.auth.user.user_role === 'OEM'"/>
          <sidebar-item :link="{ name: 'Organisation overview', path: '/oem/organisations' }" v-if="$store.state.auth.user.user_role === 'OEM'"/>
          <sidebar-item :link="{ name: 'Failed synchronizations', path: '/oem/failedsynchronizations' }" v-if="$store.state.auth.user.user_role === 'OEM'"/>
        </sidebar-item>
      </template>
    </side-bar>

    <div class="main-content">
      <dashboard-navbar></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './Navbar.vue';
import ContentFooter from './Footer.vue';
import DashboardContent from './Content.vue';
import { FadeTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
  },
  methods: {
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('scrollbar-inner');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  }
};
</script>
